import { z } from 'zod';
import { claimQuestOutputSchema } from '@zealy/utils';
export const claimStatusSchema = claimQuestOutputSchema.extend({
    comment: z.string().optional(),
});
